import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

/**
 * Create a new product variant
 */
export const createProductVariant = async (variantData) => {
  const response = await axiosInstance.post('/ProductVariant', variantData);
  return response.data;
};

/**
 * Get a product with all its variants
 * @param {number} productId
 */
export const getProductWithVariants = async (productId) => {
  const response = await axiosInstance.get(`/ProductVariant/product-with-variants/${productId}`);
  return response.data;
};

/**
 * Update a product variant
 * @param {number} id - Variant ID
 * @param {Object} variantData
 */
export const updateProductVariant = async (id, variantData) => {
  const response = await axiosInstance.put(`/ProductVariant/${id}`, variantData);
  return response.data;
};

/**
 * Delete a product variant
 * @param {number} id - Variant ID
 */
export const deleteProductVariant = async (id) => {
  const response = await axiosInstance.delete(`/ProductVariant/${id}`);
  return response.data;
};

/**
 * Get a single variant by ID
 * @param {number} id - Variant ID
 */
export const getVariantById = async (id) => {
  const response = await axiosInstance.get(`/ProductVariant/${id}`);
  return response.data;
};
